import { Typographies } from '@/theme';
import { Button, Theme, styled } from '@mui/material';

interface Props {
  guttertop?: boolean;
  variant: 'outlined' | 'contained' | 'text' | undefined;
  color:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | undefined;
}

export const ButtonContainedStyled = styled(Button)<Props>(
  ({ theme, guttertop: gutterTop, variant, color }) => ({
    textTransform: 'initial',
    padding: theme.spacing(1, 3),
    fontWeight:
      variant === 'contained'
        ? Typographies.FONT_WEIGHT_H2
        : Typographies.FONT_WEIGHT_BODY,

    boxShadow: 'none',
    borderRadius: theme.spacing(1),
    color: colorGenerator(color, variant, theme),

    background:
      color === 'primary' || color === 'secondary'
        ? theme.palette?.[color]?.main
        : 'inherir',
    ':hover': {
      background:
        color === 'primary' || color === 'secondary'
          ? theme.palette?.[color]?.light
          : 'inherir',
    },
    marginTop: gutterTop ? theme.spacing(3) : 'inherit',
  }),
);

const colorGenerator = (
  color: string | undefined,
  variant: string | undefined,
  theme: Theme,
): string | undefined => {
  if (color === 'info') return undefined;
  if (variant === 'contained') return theme.palette.white.main;
  if (variant === 'text') return theme.palette.dark.dark_4;
};
